module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABU0lEQVQokW3SPUuXYRQG8F9qKWIvJKiDOAjRCy0NOfwhfMWpkHJr6XM0BkHkR3AoagkKosWCIEVB0cU3EIdyMAcJM23JIow4cP5x89CZ7uc+13XOdV3PfeLg8LtKdeMRBvAb63iAlRLWUJwv4RWW0YN7uI1jTOE9hkpiKybwFmcwhn5MYw3jqOELJvEkVIXULfQmeK6qu1KBC/xREMPHPFrwOqceVgjn0+dgbr4WUr/hDu7jMfbwAmdz2LPcUkvMCHaa0JYTZ7CaQfRlmr/wFXfxLrd34lxDpnYqL7uTOIrPSawVpKiTwWkqPqKGcZDnT2j/T0Cx6E8QT2M/L9cLQHMxsKxddITUDXzA5QogeuUDqVtZwM9oRBAfsYg3uJqgSLsu+wJeYhOh8noQf+AmbqARs3iKi0l4ni+oC7dy0XY9nLq/aITkh7iSPsN//Pilf0j8Ba4aUJV/7CMGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/codeManger.png
// module id = xCou
// module chunks = 7